<template>
  <div
    class="video-change"
    @click="changeVideo"
  >
    替换视频
  </div>
</template>
<script>
export default {
  name: 'VideoChange',
  methods: {
    changeVideo() {
      this.$emit('changeVideo');
    }
  }
};
</script>
<style lang="scss" scoped>
.video-change {
  width: 92px;
  height: 30px;
  margin-right: 63px;
  line-height: 28px;
  background: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 0px 2px 5px 0px rgba(124, 124, 124, 0.13);
  border-radius: 15px;
  cursor: pointer;

  &:hover {
    color: #2f58fe;
    border: 1px solid #2f58fe;
  }
}
@media (max-width: 1600px) {
  .video-change {
    width: 80px;
    height: 26px;
    line-height: 26px;
    border-radius: 13px;
    font-size: 12px;
    margin-right: 40px;
  }
}
</style>
